
<sm-experiment-artifact-item-view
  *ngIf="modelInfo$ | async"
  [artifact]="selectedArtifact"
  [editable]="false">
</sm-experiment-artifact-item-view>

